import { Transforms, Editor } from 'slate';
import { INLINE_LINK } from '../../../types';

export function unwrapLink(editor: Editor) {
  Transforms.unwrapNodes(editor, { match: n => n.type === INLINE_LINK });
}
